export function getEventSource({ eventPlace, previewUrl, title }) {
  if (eventPlace === 'atom' || title.toLocaleLowerCase().includes('атом')) {
    return require('@/assets/atom-bg.png');
  }

  if (eventPlace === 'russia' || title.toLocaleLowerCase().includes('международная')) {
    return require('@/assets/russia.png')
  }

  if (title.toLocaleLowerCase().includes('хроники')) {
    return require('@/assets/chronicles-bg.png');
  }

  return previewUrl ?? require('@/assets/new-icons/landing/test-data/test-1.png')
}